export const config = {
  baseURL: "https://api.syroltech.com/tegal",
  storageBaseUrl: "https://teegal.s3.eu-north-1.amazonaws.com",
  paystackKey: "pk_live_754279644ad6c4a3c54cc0a4f79bd73f351778c6",
  partnerRequestFee: 1000000,
};
